/** Trims outer whitespace and collapses inner runs (e.g. double spaces) to one space. */
export const normalizeHolderNamePart = (value: string): string =>
	value.trim().replace(/\s+/g, ' ');

/** Strips leading whitespace so a name field can never start with a space. */
export const stripLeadingWhitespace = (value: string): string =>
	value.replace(/^\s+/, '');

/** A single name field (first or last name) must not be empty or whitespace-only. */
export const isValidHolderNamePart = (value: string): boolean =>
	normalizeHolderNamePart(value) !== '';

export const isValidHolderName = (firstName: string, lastName: string) =>
	isValidHolderNamePart(firstName) && isValidHolderNamePart(lastName);
